import React from 'react'
import { useProducts, ProductsProps } from './useProducts'
import Product from 'components/Product/Product'
import productImage from 'img/product.webp'

const Products: React.FC<ProductsProps> = (props: ProductsProps) => {
  const { products, restaurantCurrency, isAddToCartActive } = useProducts(props)
  const MEDIA_URL = process.env.REACT_APP_MEDIA_URL

  return (
    <div className='container-fluid py-3'>
      <div className='row'>
        {products.length ? (
          products.map((product) => (
            <div
              key={`product-${product.id}`}
              className='col-12 col-md-6 col-lg-4 col-xl-3 mb-4'
            >
              <Product
                id={product.id}
                name={product.name}
                currency={restaurantCurrency}
                price={product.price}
                calories={product.calories}
                protein={product.protein}
                carbs={product.carbs}
                fat={product.fat}
                priceList={product.priceList}
                description={product.description}
                image={
                  product.image ? `${MEDIA_URL}${product.image}` : productImage
                }
                isClickable={!!product.image}
                isPopular={product.isPopular}
                isVegan={product.isVegan}
                isVegetarian={product.isVegetarian}
                isGlutenFree={product.isGlutenFree}
                isHalal={product.isHalal}
                isAddToCartActive={isAddToCartActive}
              />
            </div>
          ))
        ) : (
          <div style={{ color: 'var(--footer-color)' }}>
            Nothing Found Here!
          </div>
        )}
      </div>
    </div>
  )
}

export default Products
